import React, { useState } from "react";
import PageLayout from "../components/layout/PageLayout";
import SectionHeading from "../components/shared/SectionHeading";
import SectionDivider from "../components/decor/SectionDivider";
import CTASection from "../components/shared/CTASection";
import Mandala from "../components/decor/Mandala";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { DEITIES } from "../data/deities";
import { IMG } from "../data/site";
import { Sparkles, Clock } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const DEITY_CONTENT_KN = {
  bhuvaraha: {
    title: "ಶ್ರೀ ಭೂವರಾಹ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಈ ಭೂವರಾಹ ವಿಗ್ರಹವನ್ನು ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರಿಗೆ ಅನುಗ್ರಹಿಸಿದರು.",
    paragraphs: [
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಸಂಸ್ಥಾಪಕ ಪೀಠಾಧಿಪತಿಗಳಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರಿಗೆ ಈ ಭೂವರಾಹ ವಿಗ್ರಹವನ್ನು ಅನುಗ್ರಹಿಸಿದರು. ಈ ಭೂವರಾಹ ವಿಗ್ರಹವು ವಿಶಿಷ್ಟವಾದ ರೂಪವನ್ನು ಹೊಂದಿದ್ದು, ಭೂದೇವಿಯು (ಲಕ್ಷ್ಮೀದೇವಿಯ ರೂಪ) ಭಗವಂತನ ಎಡ ತೊಡೆಯ ಮೇಲೆ ಕುಳಿತಿರುವಂತೆ, ಭಗವಾನ್ ಭೂವರಾಹನು ಸರ್ಪರಾಜನ ಹೆಡೆಯ ಮೇಲೆ ವಿರಾಜಮಾನನಾಗಿದ್ದಾನೆ. ತನ್ನ ಪತ್ನಿಗೆ ಕರುಣಾಮಯ ಆನಂದವನ್ನು ನೀಡಲು ಭಗವಂತನು ಸಂತುಷ್ಟನಾಗಿ ಉತ್ಸುಕನಾಗಿರುವಂತೆ ಕಾಣುತ್ತಾನೆ. ಇದನ್ನು ಪರಂಪರೆಯ ಪ್ರಧಾನ ಹಾಗೂ ಪ್ರೀತಿಯ ಆರಾಧ್ಯ ದೇವತೆಯಾಗಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  hayagriva: {
    title: "ಶ್ರೀ ಹಯಗ್ರೀವ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ವಾದಿರಾಜರು ಆರಾಧನೆಗಾಗಿ ಸ್ವೀಕರಿಸಿದ ಪವಾಡಸದೃಶ ಅರ್ಚಾವತಾರ.",
    paragraphs: [
      "ಒಬ್ಬ ಅಕ್ಕಸಾಲಿಗನು ವಿಘ್ನೇಶನ ವಿಗ್ರಹವನ್ನು ಮಾಡಲು ಲೋಹವನ್ನು ಅಚ್ಚಿನಲ್ಲಿ ಸುರಿಯಲು ಪ್ರಯತ್ನಿಸಿದಾಗ, ಅದು ಆಕಸ್ಮಿಕವಾಗಿ ಹಯಗ್ರೀವ ವಿಗ್ರಹವಾಗಿ ರೂಪುಗೊಂಡಿತು. ಅವನು ಮತ್ತೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿದರೂ ವಿಫಲನಾದನು. ಆ ವಿಗ್ರಹವನ್ನು ಬೇಡವಾದುದೆಂಬಂತೆ ಒಂದು ಮೂಲೆಯಲ್ಲಿ ಇಟ್ಟನು. ಆಗ ಹಯಗ್ರೀವ ರೂಪದ ಪರಮಾತ್ಮನು ಸ್ವಯಂ ಅಲ್ಲಿ ಪ್ರತ್ಯಕ್ಷನಾಗತೊಡಗಿದನು. ಅದು ಹಯಗ್ರೀವ ರೂಪದ ಅರ್ಚಾವತಾರವಾಗಿತ್ತು. ನಂತರ ಭಗವಂತನು ವಾದಿರಾಜರಿಗೆ ಕನಸಿನಲ್ಲಿ ಕಾಣಿಸಿಕೊಂಡು, ಆ ವಿಗ್ರಹವನ್ನು ನಿತ್ಯಪೂಜೆಗಾಗಿ ತೆಗೆದುಕೊಂಡು ಹೋಗುವಂತೆ ತಿಳಿಸಿದನು. ತಾನು ನೀಡಿದ ವಾಗ್ದಾನದಂತೆ ಅರ್ಚಾವತಾರವನ್ನು ಸ್ವೀಕರಿಸಿರುವುದಾಗಿ ತಿಳಿಸಿದನು. ಆ ವಿಗ್ರಹವನ್ನು ಸಂತನಿಗೆ ಸಮರ್ಪಿಸುವಂತೆ ಅಕ್ಕಸಾಲಿಗನಿಗೂ ಕನಸಿನಲ್ಲಿ ಸೂಚಿಸಿದನು. ಮರುದಿನ ವಾದಿರಾಜರು ಅಕ್ಕಸಾಲಿಗನ ಮನೆಗೆ ತೆರಳಿ, ಭಗವಂತನ ಕೃಪಾಮಯ ಹಾಗೂ ಪವಿತ್ರ ಸಾನ್ನಿಧ್ಯದಿಂದ ಪ್ರಕಾಶಿಸುತ್ತಿದ್ದ ಹಯಗ್ರೀವ ವಿಗ್ರಹವನ್ನು ಕಂಡರು. ಅದನ್ನು ತೆಗೆದುಕೊಂಡು ಭೂವರಾಹನೊಂದಿಗೆ ಪೀಠದ ಮೇಲೆ ಇರಿಸಿ ವೈಭವಯುತವಾಗಿ ಆರಾಧಿಸಿದರು. ಇದೂ ಸಹ ಪರಂಪರೆಯ ಪ್ರಧಾನ ಆರಾಧ್ಯ ದೇವತೆಯಾಗಿದೆ.",
    ],
  },
  "lakshmi-narasimha": {
    title: "ಶ್ರೀ ಲಕ್ಷ್ಮೀನರಸಿಂಹ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ವಾದಿರಾಜರು ಭೀಮಸೇನನು ಪೂಜಿಸುತ್ತಿದ್ದ ಈ ವಿಗ್ರಹವನ್ನು ಪಡೆದುಕೊಂಡರು.",
    paragraphs: [
      "ಒಮ್ಮೆ ಯಾತ್ರೆಯ ಸಂದರ್ಭದಲ್ಲಿ ವಾದಿರಾಜರು ತಮ್ಮ ಅನುಯಾಯಿಗಳೊಂದಿಗೆ ಕುರುಕ್ಷೇತ್ರ ಪ್ರದೇಶದಲ್ಲಿ ಸಂಚರಿಸುತ್ತಿದ್ದರು. ಅವರು ಭೀಮಕೊಂಡಕ್ಕೆ ತೆರಳಿ, ಭೀಮಸೇನನು ಬಳಸಿದ ಗದೆಯನ್ನು ಹೊರತೆಗೆದು ಎಲ್ಲರಿಗೂ ತೋರಿಸಿದರು. ಅಲ್ಲದೆ ಭೀಮಸೇನನು ವಿಧಿವತ್ತಾಗಿ ಪೂಜಿಸುತ್ತಿದ್ದ ಶ್ರೀ ಲಕ್ಷ್ಮೀನರಸಿಂಹನ ವಿಗ್ರಹವನ್ನೂ ಪಡೆದುಕೊಂಡರು. ಅಂದಿನಿಂದ ಆ ವಿಗ್ರಹವನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜಮಠದ ಪೀಠಾಧಿಪತಿಗಳು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸುತ್ತಿದ್ದಾರೆ.",
    ],
  },
  vitthala: {
    title: "ಶ್ರೀ ವಿಠ್ಠಲ:",
    note: "ಸೂಚನೆ: ಬ್ರಹ್ಮ ಮತ್ತು ಋಷಿ ಗೌತಮರಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟ ಈ ವಿಗ್ರಹವನ್ನು ಶ್ರೀ ವಾದಿರಾಜರು ಗೌತಮ ಗುಹೆಯಿಂದ ಪಡೆದುಕೊಂಡರು.",
    paragraphs: [
      "ಒಮ್ಮೆ ಶ್ರೀ ವಾದಿರಾಜರು ಗೌತಮ ಗುಹೆಗೆ ತೆರಳಿದರು. ಅದು ಋಷಿ ಗೌತಮನ ತಪಸ್ಸಿನ ಪವಿತ್ರ ಸ್ಥಳವಾಗಿತ್ತು. ಅಲ್ಲಿ ನಾಲ್ಕು ಮುಖಗಳ ಬ್ರಹ್ಮನು ಮೂಲತಃ ಆರಾಧಿಸಿದ್ದ ವಿಠ್ಠಲನ ವಿಗ್ರಹವನ್ನು ಕಂಡರು. ಕಠಿಣ ತಪಸ್ಸು ಮಾಡುತ್ತಿದ್ದ ಋಷಿ ಗೌತಮನಿಗೆ ಬ್ರಹ್ಮನು ಆ ವಿಗ್ರಹವನ್ನು ಅನುಗ್ರಹಿಸಿದ್ದನು. ಋಷಿ ಗೌತಮರು ಅದನ್ನು ಪೂರ್ಣ ತೃಪ್ತಿಯಿಂದ ಪೂಜಿಸಿ ಆ ಗುಹೆಯಲ್ಲೇ ಇರಿಸಿದ್ದರು. ಶ್ರೀ ವಾದಿರಾಜರು ಆ ವಿಗ್ರಹವನ್ನು ಪಡೆದುಕೊಂಡು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸುತ್ತಿದ್ದರು.",
    ],
  },
  "kadugolu-krishna": {
    title: "ಕಡುಗೋಲು ಶ್ರೀ ಕೃಷ್ಣ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೂಜಿಸುತ್ತಿದ್ದ ಈ ವಿಗ್ರಹವನ್ನು ನಂತರ ಶ್ರೀ ವಾದಿರಾಜ ಮಠಕ್ಕೆ ನೀಡಲಾಯಿತು.",
    paragraphs: [
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೀಠಾಧಿಪತಿಗಳು ಮತ್ತು ಗೃಹಸ್ಥರನ್ನು ಒಳಗೊಂಡ ಅನೇಕ ಶಿಷ್ಯರಿಗೆ ವಿವಿಧ ವಿಗ್ರಹಗಳನ್ನು ಅನುಗ್ರಹಿಸಿದ್ದರು. ಕೈಗಳಲ್ಲಿ ಕಡಗೋಲು ಮತ್ತು ಹಗ್ಗವನ್ನು ಹಿಡಿದಿರುವ, ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರಿಂದ ಪೂಜಿಸಲ್ಪಟ್ಟ ಕೃಷ್ಣನ ವಿಗ್ರಹವನ್ನು ಸಂಬಂಧಪಟ್ಟ ಗೃಹಸ್ಥರ ವಂಶಸ್ಥರು ವೃಂದಾವನಾಚಾರ್ಯರ (1774-1865) ಕಾಲದಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜ ಮಠಕ್ಕೆ ನೀಡಿದರು. ಅಂದಿನಿಂದ ಅದನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
    ],
  },
  "garudavahana-lakshminarayana": {
    title: "ಗರುಡವಾಹನ ಶ್ರೀ ಲಕ್ಷ್ಮೀನಾರಾಯಣ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೂಜಿಸಿದ, ಗರುಡನ ಮೇಲೆ ಆಸೀನರಾಗಿರುವ ಶ್ರೀ ಲಕ್ಷ್ಮೀನಾರಾಯಣನ ವಿಗ್ರಹ.",
    paragraphs: [
      "ಇದನ್ನೂ ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪೂಜಿಸುತ್ತಿದ್ದರು. ತನ್ನ ಪತ್ನಿಯಾದ ಲಕ್ಷ್ಮೀದೇವಿಯೊಂದಿಗೆ ಭಗವಾನ್ ನಾರಾಯಣನು ತನ್ನ ವಾಹನವಾದ ಗರುಡನ ಮೇಲೆ ಆಸೀನನಾಗಿದ್ದಾನೆ. ಇದನ್ನು ಬಲಮುರಿ ಶಂಖದೊಂದಿಗೆ ಪ್ರತಿದಿನ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "rama-vitthala": {
    title: "ಶ್ರೀ ರಾಮ ಮತ್ತು ಶ್ರೀ ವಿಠ್ಠಲ",
    note: "ಸೂಚನೆ: ವಾಲಿ ಮತ್ತು ಸುಗ್ರೀವರಿಗೆ ಬ್ರಹ್ಮನು ಅನುಗ್ರಹಿಸಿದ ವಿಗ್ರಹಗಳನ್ನು ನಂತರ ಶ್ರೀ ವಾದಿರಾಜರು ಭೂಗರ್ಭದಿಂದ ಹೊರತೆಗೆದರು.",
    paragraphs: [
      "ಒಮ್ಮೆ ವಾಲಿ ಮತ್ತು ಸುಗ್ರೀವರು ತಪಸ್ಸು ಮಾಡಿ ಬ್ರಹ್ಮನನ್ನು ಪ್ರಸನ್ನಗೊಳಿಸಿದರು. ಅವರ ತಪಸ್ಸಿನಿಂದ ಸಂತುಷ್ಟನಾದ ಬ್ರಹ್ಮನು ಶ್ರೀ ರಾಮ ಮತ್ತು ಶ್ರೀ ವಿಠ್ಠಲರ ವಿಗ್ರಹಗಳನ್ನು ಅನುಗ್ರಹಿಸಿದನು. ವಾಲಿ ಮತ್ತು ಸುಗ್ರೀವರು ಆ ವಿಗ್ರಹಗಳನ್ನು ವಿಶೇಷ ಭಕ್ತಿಯಿಂದ ಪೂಜಿಸಿದರು. ತ್ರೇತಾಯುಗದ ಅಂತ್ಯದಲ್ಲಿ ಆ ವಿಗ್ರಹಗಳನ್ನು ಅಪಾರ ನಿಧಿಯೊಂದಿಗೆ ಭೂಗರ್ಭದಲ್ಲಿ ಇರಿಸಲಾಯಿತು. ಈ ಯುಗದಲ್ಲಿ ವಾದಿರಾಜರು ತಮ್ಮ ಅಂತರ್ಜ್ಞಾನದಿಂದ ಈ ಸಂಗತಿಯನ್ನು ತಿಳಿದಿದ್ದರು. ವಿಜಯನಗರ ಸಾಮ್ರಾಜ್ಯವು ಆರ್ಥಿಕ ಸಂಕಷ್ಟವನ್ನು ಎದುರಿಸುತ್ತಿದ್ದಾಗ, ಸುಮಾರು 1527 ಕ್ರಿ.ಶ.ರಲ್ಲಿ ವಾದಿರಾಜರು ವಿಜಯನಗರಕ್ಕೆ ತೆರಳಿ ಆ ಅಪಾರ ನಿಧಿಯನ್ನು ಹೊರತೆಗೆದು ಕೃಷ್ಣದೇವರಾಯ ಮತ್ತು ಅಚ್ಯುತರಾಯರಿಗೆ ನೀಡಿದರು. ಆ ರಾಮ ಮತ್ತು ವಿಠ್ಠಲರ ಎರಡು ವಿಗ್ರಹಗಳನ್ನು ತೆಗೆದುಕೊಂಡು ಪ್ರತಿದಿನ ಪೂಜಿಸಿದರು.",
      "I. ರಾಮನ ವಿಗ್ರಹವು ಶಿಖರ ಮತ್ತು ಪಾದಗಳಲ್ಲಿ ಸುದರ್ಶನವನ್ನು ಹೊಂದಿರುವ ಬೆಳ್ಳಿಯಿಂದ ಮಾಡಲ್ಪಟ್ಟಂತೆ ಕಾಣುತ್ತದೆ.",
      "II. ಶ್ರೀ ವಿಠ್ಠಲ",
    ],
  },
  "srinivasa-sridevi-bhudevi": {
    title: "ಶ್ರೀನಿವಾಸನು ಶ್ರೀದೇವಿ ಮತ್ತು ಭೂದೇವಿಯೊಂದಿಗೆ:",
    note: "ಸೂಚನೆ: ತಿರುಪತಿ ಯಾತ್ರೆಯ ನಂತರ ಶ್ರೀ ವಾದಿರಾಜರಿಗೆ ಅನುಗ್ರಹಿಸಲ್ಪಟ್ಟ ವಿಗ್ರಹಗಳು.",
    paragraphs: [
      "ಒಮ್ಮೆ ವಾದಿರಾಜರು ಭಗವಾನ್ ವೆಂಕಟೇಶ್ವರನ ದರ್ಶನವನ್ನು ಪಡೆಯಬೇಕೆಂದು ಬಯಸಿದರು. ಅವರು ತಿರುಪತಿಗೆ ಬಂದಾಗ, ಮೆಟ್ಟಿಲುಗಳ ಕಲ್ಲುಗಳು ಶಾಲಿಗ್ರಾಮಗಳಂತೆ ಕಾಣುವುದನ್ನು ಕಂಡು ಅವುಗಳ ಮೇಲೆ ಕಾಲಿಡಲು ಸಂಕೋಚಿಸಿದರು. ಆದ್ದರಿಂದ ಭಗವಂತನ ಮಹಿಮೆಯನ್ನು ಹಾಡುತ್ತಾ ಮೊಣಕಾಲಿನ ಮೇಲೆ ಬೆಟ್ಟವನ್ನು ಏರಿದರು. ವಾದಿರಾಜರು ಆ ಪ್ರಧಾನ ದೇವತೆಯನ್ನು ಸಂಪೂರ್ಣ ತೃಪ್ತಿಯಾಗುವಂತೆ ಪೂಜಿಸಿ, ನೂರಾ ಎಂಟು ಶಾಲಿಗ್ರಾಮಗಳ ಹಾರವನ್ನು ಅರ್ಪಿಸಿದರು. ಆ ಶಾಲಿಗ್ರಾಮಗಳ ಹಾರವು ಇಂದಿಗೂ ಭಗವಂತನನ್ನು ಅಲಂಕರಿಸುತ್ತದೆ. ಭಗವಂತನು ಅತ್ಯಂತ ಸಂತುಷ್ಟನಾಗಿ ಶ್ರೀ ಮತ್ತು ಭೂ ಸಮೇತ ತನ್ನ ವಿಗ್ರಹವನ್ನು ವಾದಿರಾಜರಿಗೆ ಅನುಗ್ರಹಿಸಿದನು. ಆ ವಿಗ್ರಹಗಳಲ್ಲಿ ಶ್ರೀ ಮತ್ತು ಭೂ ಸಮೇತ ಶ್ರೀನಿವಾಸನ ಕೃಪಾಮಯ ಸಾನ್ನಿಧ್ಯವು ಸಂಪೂರ್ಣವಾಗಿದೆ. ಅಂದಿನಿಂದ ಆ ವಿಗ್ರಹಗಳನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
    ],
  },
  "pacche-vitthala": {
    title: "ಪಚ್ಚೆ ವಿಠ್ಠಲ:",
    note: "ಸೂಚನೆ: ಮೂಡಬಿದಿರೆಯ ಜೈನ ದೇವಾಲಯದಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರು ಪಡೆದ ಪಚ್ಚೆಯ ವಿಠ್ಠಲ ವಿಗ್ರಹ.",
    paragraphs: [
      "ಒಮ್ಮೆ ವಾದಿರಾಜರು ಮೂಡಬಿದಿರೆ ಮೂಲಕ ಸಂಚರಿಸುತ್ತಿದ್ದರು. ಆ ಪ್ರದೇಶದ ರಾಜನು ಭಕ್ತಿಪೂರ್ವಕವಾಗಿ ಅವರನ್ನು ಜೈನ ದೇವಾಲಯಕ್ಕೆ ಆಹ್ವಾನಿಸಿದನು. ರಾಜನ ಭಕ್ತಿ ಮತ್ತು ಗೌರವವನ್ನು ಕಂಡ ವಾದಿರಾಜರು ಆಹ್ವಾನವನ್ನು ಸ್ವೀಕರಿಸಿದರು. ದೇವಾಲಯವನ್ನು ಪ್ರವೇಶಿಸುವಾಗ ಅವರು ಭಗವಂತನ ವಿಠ್ಠಲ ರೂಪವನ್ನು ಆಳವಾಗಿ ಧ್ಯಾನಿಸುತ್ತಿದ್ದರು. ಅದರ ಪರಿಣಾಮವಾಗಿ ಶುದ್ಧ ಜಿನ ವಿಗ್ರಹವು ವಿಠ್ಠಲ ರೂಪಕ್ಕೆ ಪರಿವರ್ತಿತವಾಯಿತು. ವಾದಿರಾಜರು ಆ ಪಚ್ಚೆಯ ವಿಗ್ರಹವನ್ನು ತೆಗೆದುಕೊಂಡು ಪ್ರತಿದಿನ ಪೂಜಿಸುತ್ತಿದ್ದರು. ಇಂದಿಗೂ ಅದನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
    ],
  },
  "hayagriva-vishnutirtha": {
    title: "ಶ್ರೀ ಹಯಗ್ರೀವ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರು ತಮ್ಮ ಭೇಟಿಯ ಸಾಕ್ಷಿಯಾಗಿ ಶ್ರೀ ವಾದಿರಾಜರಿಗೆ ನೀಡಿದ ವಿಗ್ರಹ.",
    paragraphs: [
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರ ಸಹೋದರರಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರ ಬಳಿ ವಿಶೇಷ ಆರಾಧನೆಗಾಗಿ ಹಯಗ್ರೀವ ವಿಗ್ರಹವಿತ್ತು. ವಾದಿರಾಜರು ಹರಿಶ್ಚಂದ್ರ ಪರ್ವತಕ್ಕೆ ತೆರಳಿ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥರನ್ನು ಪ್ರತ್ಯಕ್ಷವಾಗಿ ಭೇಟಿಯಾದಾಗ, ತಮ್ಮ ಭೇಟಿಯ ಸಾಕ್ಷಿಯಾಗಿ ಆ ಹಯಗ್ರೀವ ವಿಗ್ರಹವನ್ನು ಅವರಿಗೆ ನೀಡಿದರು. ಅಂದಿನಿಂದ ಆ ಪ್ರತಿಮೆಯನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪ್ರತಿದಿನ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
    ],
  },
  vyasamushti: {
    title: "ಶ್ರೀ ವ್ಯಾಸಮುಷ್ಟಿ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಪಡೆದ ಪವಿತ್ರ ವ್ಯಾಸಮುಷ್ಟಿ ಶಾಲಿಗ್ರಾಮವನ್ನು ಸೋದೆಗೆ ತರಲಾಯಿತು.",
    paragraphs: [
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಊರ್ಧ್ವಬದರಿಯನ್ನು ಸಂದರ್ಶಿಸಿದಾಗ ಅವರಿಗೆ ಎಂಟು ವ್ಯಾಸಮುಷ್ಟಿಗಳು ದೊರೆತವು. ಮಧ್ವಾಚಾರ್ಯರು ಒಂದು ವ್ಯಾಸಮುಷ್ಟಿ ಶಾಲಿಗ್ರಾಮವನ್ನು ಮಧ್ಯಮಠದಲ್ಲಿ ಇಟ್ಟು ಪೂಜಿಸಿದರು. ಎಂಟು ಮಠಗಳ ಸಂತ ಪೀಠಾಧಿಪತಿಗಳು ತಮ್ಮ ಅನುಕೂಲಕ್ಕೆ ತಕ್ಕಂತೆ ಅದನ್ನು ಪೂಜಿಸುತ್ತಿದ್ದರು. ವಾದಿರಾಜರು ಆ ವ್ಯಾಸಮುಷ್ಟಿಯನ್ನು ಮತ್ತೆ ತಂದು ಮಧ್ಯಮಠದಲ್ಲಿ ಇರಿಸಿದಾಗ, ಆ ಮಠವು ಸೋದೆ ವಾದಿರಾಜಮಠದ ಸ್ವಾಧೀನಕ್ಕೆ ಬಂತು. ವೃಂದಾವನಖ್ಯಾನದ ಸೂಚನೆಯಂತೆ ವೃಂದಾವನಾಚಾರ್ಯರು ಅದನ್ನು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಹಯಗ್ರೀವ ಮತ್ತು ಭೂವರಾಹ ವಿಗ್ರಹಗಳ ನಡುವೆ ಇರಿಸಿ ಪೂಜಿಸಿದರು. ನಂತರ ಆ ಶಾಲಿಗ್ರಾಮವನ್ನು ಕೃಷ್ಣಸನ್ನಿಧಿಗೆ ತಂದು ಸಮಾನಾಧಿಕರಣ ಪೂಜೆಯನ್ನು ನೆರವೇರಿಸಿದರು. ನಿತ್ಯಪೂಜೆಯ ಸಂದರ್ಭದಲ್ಲಿ ವ್ಯಾಸಮುಷ್ಟಿಗೆ ವಿಶೇಷ ಆರಾಧನೆ ಸಲ್ಲಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "paryaya-krishna": {
    title: "ಪರ್ಯಾಯ ಶ್ರೀ ಕೃಷ್ಣ:",
    note: "ಸೂಚನೆ: ಸೋದೆಯಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರು ತಮ್ಮ ಪರ್ಯಾಯದ ಸಂದರ್ಭದಲ್ಲಿ ಬಳಸಿದ ಕೃಷ್ಣನ ವಿಗ್ರಹ.",
    paragraphs: [
      "ವಾದಿರಾಜರು ಐದನೇ ಪರ್ಯಾಯದ ನಿರ್ವಹಣೆಯನ್ನು ತಮ್ಮ ಶಿಷ್ಯರಾದ ಶ್ರೀ ವೇದವೇದ್ಯತೀರ್ಥರಿಗೆ ವಹಿಸಿ ಸೋದೆಗೆ ಬಂದರು. ಅಲ್ಲಿ ವೇಣುಗೋಪಾಲ ಕೃಷ್ಣನ ಪವಿತ್ರ ಸನ್ನಿಧಿಯಲ್ಲಿ ಉಡುಪಿಯ ಕೃಷ್ಣ ಪರ್ಯಾಯದಂತೆಯೇ ತಮ್ಮ ಪರ್ಯಾಯವನ್ನು ನೆರವೇರಿಸಿದರು. ವಿಶೇಷ ನೈವೇದ್ಯ ಮತ್ತು ಆರಾಧನೆಗಾಗಿ ವಾದಿರಾಜರು ಶ್ರೀ ಕೃಷ್ಣನ ಸಣ್ಣ ವಿಗ್ರಹವನ್ನು ಹೊಂದಿದ್ದರು. ಪರ್ಯಾಯದ ನಂತರ ಆ ವಿಗ್ರಹವನ್ನು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪೀಠಾಧಿಪತಿಗಳು ಪರಂಪರಾ ಪೀಠದಲ್ಲಿ ಪ್ರತಿದಿನ ಪೂಜಿಸುತ್ತಿದ್ದಾರೆ.",
    ],
  },
  srimushnavaraha: {
    title: "ಶ್ರೀಮುಷ್ಣವರಾಹ:",
    note: "ಸೂಚನೆ: ಶ್ರೀಮುಷ್ಣದಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರಿಗೆ ಕೃಪೆಯಿಂದ ಪ್ರಕಟವಾದ ವರಾಹ ವಿಗ್ರಹ.",
    paragraphs: [
      "ವಾದಿರಾಜರು ಶ್ರೀಮುಷ್ಣದ ಪವಿತ್ರ ಕ್ಷೇತ್ರಕ್ಕೆ ತೆರಳಿ ಭಗವಾನ್ ವರಾಹನನ್ನು ಭಕ್ತಿ ಮತ್ತು ವಿಧಿಪೂರ್ವಕವಾಗಿ ಆರಾಧಿಸಿದರು. ಇದರಿಂದ ಅತ್ಯಂತ ಸಂತುಷ್ಟನಾದ ಭಗವಾನ್ ವರಾಹನು ಸಣ್ಣ ವಿಗ್ರಹದ ರೂಪದಲ್ಲಿ ಪ್ರತ್ಯಕ್ಷನಾಗಿ ವಾದಿರಾಜರಿಗೆ ಕೃಪಾನುಗ್ರಹ ನೀಡಿದನು. ಆ ವರಾಹ ವಿಗ್ರಹವನ್ನು ಸೋದೆ ಮಠದಲ್ಲಿ ವಿಶೇಷ ಆರಾಧನೆಯೊಂದಿಗೆ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "vishvambhara-saligrama": {
    title: "ಶ್ರೀ ವಿಶ್ವಂಭರ ಶಾಲಿಗ್ರಾಮ",
    note: "ಸೂಚನೆ: ಗೌತಮ ಗುಹೆಯಲ್ಲಿ ದೊರೆತ ಪವಿತ್ರ ಶಾಲಿಗ್ರಾಮವನ್ನು ಶ್ರೀ ವಾದಿರಾಜರು ಪೂಜಿಸಿದರು.",
    paragraphs: [
      "ಇದು ಗೌತಮ ಗುಹೆಯಲ್ಲಿ ದೊರೆಯಿತು. ವಾದಿರಾಜರು ಇದನ್ನು ವಿಠ್ಠಲ ವಿಗ್ರಹದೊಂದಿಗೆ ತಂದು ಸಂಸ್ಥಾನ ಪೀಠದ ಮೇಲೆ ಇರಿಸಿ ಪ್ರತಿದಿನ ಪೂಜಿಸಿದರು.",
    ],
  },
  "mukhyaprana-vadiraja": {
    title: "ಶ್ರೀ ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ಶ್ರೀ ವಾದಿರಾಜರು",
    note: "ಸೂಚನೆ: ಸಮತ್ವದ ತತ್ತ್ವವನ್ನು ಸೂಚಿಸುವಂತೆ ಎರಡೂ ವಿಗ್ರಹಗಳನ್ನು ಒಟ್ಟಿಗೆ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    paragraphs: [
      "ಶ್ರೀ ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ಶ್ರೀ ವಾದಿರಾಜರ ವಿಗ್ರಹಗಳನ್ನು ಒಂದೇ ತಟ್ಟೆಯಲ್ಲಿ ಇರಿಸಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ವಾದಿರಾಜರ ವಿಗ್ರಹವನ್ನು ವಾದಿರಾಜರೇ ತಯಾರಿಸಿ, ಯಾತ್ರೆಗೆ ಹೊರಡುವ ಸಂದರ್ಭದಲ್ಲಿ ತಮ್ಮ ತಾಯಿಗೆ ನೀಡಿದ್ದರು. ಇದರಿಂದ ವಾದಿರಾಜರು ದೈಹಿಕವಾಗಿ ದೂರವಿದ್ದಾಗ ಉಂಟಾಗಬಹುದಾದ ವಿರಹಭಾವವು ದೂರವಾಯಿತು. ವಾದಿರಾಜರು ಲತವ್ಯ ರಿಜು ದೇವರಾಗಿರುವುದರಿಂದ ಅವರನ್ನು ಮುಖ್ಯಪ್ರಾಣರೊಂದಿಗೆ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ಈ ಪೂಜಾ ವಿಧಾನವು ಸಮತ್ವದ ಅಂಶವನ್ನು ಸೂಚಿಸುತ್ತದೆ. ವಿಗ್ರಹದ ಭಂಗಿಯು ಮುಖ್ಯಪ್ರಾಣರಂತೆ ವಾದಿರಾಜರೂ ಗರುಡ, ಶೇಷ ಮುಂತಾದವರ ಲೋಕಕ್ಕೆ ಪ್ರಧಾನ ಆಧಾರವಾಗಿದ್ದಾರೆ ಎಂಬುದನ್ನು ದೃಢಪಡಿಸುತ್ತದೆ.",
    ],
  },
  suvarnapaduka: {
    title: "ಸುವರ್ಣಪಾದುಕಾ ಶ್ರೀ ವಾದಿರಾಜರು:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ವಾದಿರಾಜರ ಸುವರ್ಣ ಪಾದುಕೆಗಳು ಅವರ ಕೃಪಾಮಯ ಸಾನ್ನಿಧ್ಯದ ಸಂಕೇತವಾಗಿ ಪೂಜಿಸಲ್ಪಡುತ್ತವೆ.",
    paragraphs: [
      "ವಾದಿರಾಜರ ಎರಡು ಸುವರ್ಣ ಪಾದುಕೆಗಳನ್ನೂ ಭಕ್ತಿಪೂರ್ವಕವಾಗಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ಈ ಪಾದುಕೆಗಳು ಮೂಲತಃ ದೈವಿಕ ಲೋಕಕ್ಕೆ (ಸ್ವರ್ಗಕ್ಕೆ) ಸೇರಿದ್ದವು. ದೇವೇಂದ್ರ ಮತ್ತು ಇತರ ದೇವತೆಗಳು ಅವುಗಳನ್ನು ವಾದಿರಾಜರ ಕೃಪಾಮಯ ಸಾನ್ನಿಧ್ಯದ ಪ್ರತಿರೂಪಗಳೆಂದು ಭಾವಿಸಿ ಗೌರವ ಮತ್ತು ಭಕ್ತಿಯಿಂದ ಪೂಜಿಸುತ್ತಿದ್ದರು. ಮಾನವಕುಲದ ಕಲ್ಯಾಣಕ್ಕಾಗಿ ದೈವಿಕ ಅನುಗ್ರಹದಿಂದ ಈ ಸುವರ್ಣ ಪಾದುಕೆಗಳು ಭೂಲೋಕಕ್ಕೆ ಬಂದವು. ವೃಂದಾವನ ಪ್ರವೇಶದ ನಂತರ ವಾದಿರಾಜರು ಅದೇ ರೂಪದಲ್ಲಿ ದೈವಿಕ ಲೋಕದಲ್ಲಿ ಪ್ರತ್ಯಕ್ಷರಾಗಿ, ಕರುಣೆಯಿಂದ ತಮ್ಮ ಪವಿತ್ರ ಸಾನ್ನಿಧ್ಯದ ಪಾದುಕೆಗಳನ್ನು ಶಿಷ್ಯರಿಗೆ ಅನುಗ್ರಹಿಸಿದರು. ಈ ಸುವರ್ಣ ಪಾದುಕೆಗಳನ್ನು ಮುಖ್ಯಪ್ರಾಣ ಮತ್ತು ವಾದಿರಾಜರ ವಿಗ್ರಹಗಳೊಂದಿಗೆ ಪ್ರತಿದಿನ ವೈಭವಯುತವಾಗಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "saligrama-samputa": {
    title: "ಸಾಲಿಗ್ರಾಮ ಸಂಪುಟ:",
    note: "ಸೂಚನೆ: ದಾಮೋದರಕುಂಡದಲ್ಲಿ ಶ್ರೀ ವಾದಿರಾಜರು ಸಂಗ್ರಹಿಸಿದ ಸಾಲಿಗ್ರಾಮಗಳನ್ನು ಒಳಗೊಂಡ ಸಂಪುಟ.",
    paragraphs: [
      "ಯಾತ್ರೆಯ ಸಂದರ್ಭದಲ್ಲಿ ವಾದಿರಾಜರು ನೇಪಾಳಕ್ಕೆ ತೆರಳಿ ಗಂಡಕಿ ನದಿಯ ಉಗಮಸ್ಥಳವಾದ ದಾಮೋದರಕುಂಡವನ್ನು ತಲುಪಿದರು. ಅಲ್ಲಿ ಪವಿತ್ರ ಸ್ನಾನ ಮಾಡಿದಾಗ, ಸಾಲಿಗ್ರಾಮಗಳಲ್ಲಿ ನೆಲೆಸಿದ್ದ ಭಗವಂತನು ವಾದಿರಾಜರ ದೇಹಕ್ಕೆ ಅಂಟಿಕೊಂಡನು. ಇದು ಮೂರು ಬಾರಿ ಸಂಭವಿಸಿತು. ಗುಲಗಂಜಿಯಷ್ಟು ಸಣ್ಣ ಗಾತ್ರದ ಸಾಲಿಗ್ರಾಮಗಳನ್ನು ಸಂಗ್ರಹಿಸಿ ಸಂಪುಟದಲ್ಲಿ ಇರಿಸಲಾಯಿತು. ಅಂದಿನಿಂದ ಆ ಸಂಪುಟವನ್ನು ಸೋದೆ ಮಠದಲ್ಲಿ ಪ್ರತಿದಿನ ಪೂಜಿಸಲಾಗುತ್ತಿದೆ.",
    ],
  },
  "bhutarajaru-padmapeetha": {
    title: "ಶ್ರೀ ಭೂತರಾಜರು (ಪದ್ಮಪೀಠ):",
    note: "ಸೂಚನೆ: ಶ್ರೀ ವಾದಿರಾಜರಿಂದ ಅನುಗ್ರಹಿಸಲ್ಪಟ್ಟ ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪರಂಪರೆಯ ರಕ್ಷಕ.",
    paragraphs: [
      "ಮುಂದಿನ ಕಲ್ಪದಲ್ಲಿ ಶಿವನ ಸ್ಥಾನವನ್ನು ಅಲಂಕರಿಸಲು ಅರ್ಹರಾದ ದೈವಿಕ ಜೀವಿಯಾದ ಶ್ರೀ ಭೂತರಾಜರು ಅತೀಂದ್ರಿಯ ಶಕ್ತಿಯನ್ನು ಹೊಂದಿದ್ದಾರೆ. ವಾದಿರಾಜರಿಂದ ಅನುಗ್ರಹಿಸಲ್ಪಟ್ಟ ಭೂತರಾಜರು ಅನೇಕ ಸ್ಥಳಗಳಲ್ಲಿ ಉಪಸ್ಥಿತರಿದ್ದು ಭಕ್ತ ಸಮೂಹವನ್ನು ರಕ್ಷಿಸುತ್ತಿದ್ದಾರೆ. ಸೋದೆ ಮತ್ತು ಇತರ ಸ್ಥಳಗಳಲ್ಲಿ ಅವರು ಹರಿ-ವಾಯು-ವಾದಿರಾಜರ ಪಾದಸೇವೆಯನ್ನು ಮಾಡುತ್ತಿದ್ದಾರೆ. ಅವರು ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪರಂಪರೆಯ ರಕ್ಷಕರಾಗಿದ್ದಾರೆ. ಸೋದೆ ಮಠದಲ್ಲಿರುವ ಪದ್ಮಪೀಠವು ಶ್ರೀ ಭೂತರಾಜರ ಪವಿತ್ರ ಸಾನ್ನಿಧ್ಯದಿಂದ ಸಂಪೂರ್ಣವಾಗಿ ತುಂಬಿದೆ. ಅದನ್ನು ವಿಶೇಷ ನೈವೇದ್ಯ ಮತ್ತು ಆರಾಧನೆಯೊಂದಿಗೆ ಪೂಜಿಸಲಾಗುತ್ತದೆ. ಇದೇ ರೀತಿಯಾಗಿ ಭಗವಂತನ ದಧಿವಾಮನ ರೂಪದ ಸಣ್ಣ ಶಾಲಿಗ್ರಾಮವನ್ನೂ ಭಕ್ತಿಪೂರ್ವಕವಾಗಿ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "akshayapatre-mudreyungura": {
    title: "ಅಕ್ಷಯಪಾತ್ರೆ ಮತ್ತು ಮುದ್ರೆಯುಂಗುರ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥಾಚಾರ್ಯರಿಗೆ ಅನುಗ್ರಹಿಸಿದ ಪವಿತ್ರ ಪಾತ್ರೆ ಮತ್ತು ಮುದ್ರೆಯುಂಗುರ.",
    paragraphs: [
      "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ತಮ್ಮ ಅರ್ಹ ಮತ್ತು ಭಕ್ತಿಯುತ ಸಹೋದರರಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥಾಚಾರ್ಯರಿಗೆ ಈ ಪಾತ್ರೆ ಮತ್ತು ಮುದ್ರೆಯುಂಗುರವನ್ನು ನೀಡಿದರು. ಮುದ್ರೆಯುಂಗುರದ ಮೇಲೆ ‘ಶ್ರೀಕೃಷ್ಣಶ್ರೀ’ ಎಂಬ ಅಕ್ಷರಗಳು ಕೆತ್ತಲ್ಪಟ್ಟಿವೆ. ಅಕ್ಷಯಪಾತ್ರೆಯನ್ನು ಸಂಸ್ಥಾನ ಪೂಜೆಯ ಆರಂಭದಲ್ಲಿ ಪ್ರತಿದಿನ ಪೂಜಿಸಲಾಗುತ್ತದೆ.",
    ],
  },
  "mantrakshate-tatte": {
    title: "ಮಂತ್ರಾಕ್ಷತೆ ತಟ್ಟೆ:",
    note: "ಸೂಚನೆ: ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥಾಚಾರ್ಯರಿಗೆ ಅನುಗ್ರಹಿಸಿದ ಪವಿತ್ರ ತಟ್ಟೆ.",
    paragraphs: [
      "ಈ ತಟ್ಟೆಯನ್ನು ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರು ತಮ್ಮ ಪ್ರೀತಿಯ ಸಹೋದರರಾದ ಶ್ರೀ ವಿಷ್ಣುತೀರ್ಥಾಚಾರ್ಯರಿಗೆ ಅನುಗ್ರಹಿಸಿದರು. ಈ ತಟ್ಟೆಯಲ್ಲಿ ಈ ಪ್ರಸಿದ್ಧ ಪರಂಪರೆಯ ಎಲ್ಲಾ ಸಂತ ಪೀಠಾಧಿಪತಿಗಳ ಪವಿತ್ರ ಸ್ಪರ್ಶದ ಮಹಿಮೆಯನ್ನು ಸಾರುವ ಪಾವಿತ್ರ್ಯದ ಶ್ರೇಷ್ಠತೆ ಅಡಗಿದೆ.",
    ],
  },
};

const Deities = () => {
  const { t, lang } = useLang();
  const pick = (d, key) => (lang === "kn" && d[`${key}Kn`]) || d[key];
  const copy = {
    awaitingDarshana: lang === "kn" ? "ದರ್ಶನ ಚಿತ್ರ ನಿರೀಕ್ಷೆಯಲ್ಲಿದೆ" : "Awaiting Darshana",
    imageComingSoon: lang === "kn" ? "ಪವಿತ್ರ ಮೂರ್ತಿಯ ಚಿತ್ರವನ್ನು ಶೀಘ್ರದಲ್ಲೇ ಸೇರಿಸಲಾಗುತ್ತದೆ" : "The sacred icon image will be added shortly",
    experienceSode: lang === "kn" ? "ಸೋದೆ ಅನುಭವಿಸಿ" : "Experience Sode",
    planDarshana: lang === "kn" ? "ವೈಯಕ್ತಿಕ ದರ್ಶನಕ್ಕಾಗಿ ಭೇಟಿಯನ್ನು ಯೋಜಿಸಿ" : "Plan a visit for personal darshana",
    templeTimings: lang === "kn" ? "ದೇವಸ್ಥಾನ ಸಮಯಗಳು" : "Temple Timings",
    reachSode: lang === "kn" ? "ಸೋದೆಗೆ ತಲುಪುವ ಮಾರ್ಗ" : "How to reach Sode",
  };
  const [openDeity, setOpenDeity] = useState(null);

  return (
    <PageLayout>
      {/* Gallery - mirrors Home "Divine deities of Sode Matha" design */}
      <section
        className="py-20 sm:py-16 relative"
        data-testid="deities-gallery"
        style={{ background: "linear-gradient(180deg, #E4D3B1 0%, #DFCCA6 100%)" }}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <SectionHeading
            eyebrow={t("deities.hero.eyebrow")}
            title={t("deities.hero.title")}
            subtitle={ lang === "kn" ? 'ಶ್ರೀ ಸೋದೆ ವಾದಿರಾಜ ಮಠದ ಪರಂಪರೆಯಲ್ಲಿ ನಿತ್ಯವೂ ಪೂಜಿಸಲ್ಪಡುವ ಮೂರ್ತಿಗಳು.' : 'The icons being worshipped daily in the lineage of Sri Sode Vadiraja Matha'}
            align="center"
          />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 auto-rows-fr">
            {DEITIES.map((d) => (
              <button
                key={d.slug}
                onClick={() => setOpenDeity(d)}
                className="group text-left relative rounded-2xl overflow-hidden border border-[#D4AF37]/30 card-lift bg-[#FBF7F0] flex flex-col h-full"
                data-testid={`deity-btn-${d.slug}`}
              >
                <div className="aspect-square overflow-hidden relative shrink-0">
                  {d.isIdol ? (
                    <div className="absolute inset-0 bg-gradient-to-b from-[#FBF7F0] via-[#F2E7D5] to-[#E4D3B1] flex items-center justify-center">
                      <div className="absolute inset-0 flex items-center justify-center opacity-45 animate-mandala-slow">
                        <Mandala size={280} color="#B65A14" opacity={0.5} />
                      </div>
                      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 45%, rgba(201,162,39,0.30) 0%, transparent 65%)" }} />
                      {d.image ? (
                        <img
                          src={d.image}
                          alt={d.name}
                          className={`relative z-10 object-contain transition-transform duration-700 group-hover:scale-105 ${d.slug === "bhuvaraha" ? "max-h-[62%] max-w-[52%]" : "max-h-[100%] max-w-[100%]"}`}
                          style={{ filter: "drop-shadow(0 10px 22px rgba(51, 36, 28, 0.4))" }}
                        />
                      ) : (
                        <div className="relative z-10 text-center px-4">
                          <div className="w-20 h-20 mx-auto rounded-full border-2 border-[#B65A14]/60 flex items-center justify-center mb-3 bg-[#FBF7F0]/80">
                            <Sparkles className="w-8 h-8 text-[#B65A14]" />
                          </div>
                          <div className="font-serif-display text-base text-[#B65A14]">{copy.awaitingDarshana}</div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <img src={d.image} alt={d.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#3B2A1A] via-[#3B2A1A]/30 to-transparent" />
                    </>
                  )}
                </div>
                <div className="bg-gradient-to-b from-[#B65A14] to-[#8F4610] px-4 py-3 relative z-20 h-[104px] flex flex-col items-center justify-center" data-testid={`deity-caption-${d.slug}`}>
                  {/* <div className="font-cinzel text-xs tracking-widest text-[#D4AF37] mb-0.5 text-center">{d.sanskrit}</div> */}
                  <div className="font-serif-display text-xl sm:text-2xl text-[#FBF7F0] font-semibold leading-tight text-center">{pick(d, "name")}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!openDeity} onOpenChange={(o) => !o && setOpenDeity(null)}>
        <DialogContent
          className="w-[calc(100vw-1.5rem)] max-w-3xl max-h-[calc(100dvh-1.5rem)] bg-[#FBF7F0] border-[#D4AF37]/40 p-0 overflow-y-auto overflow-x-hidden [&>button]:z-50 [&>button]:rounded-full [&>button]:bg-[#3B2A1A]/85 [&>button]:p-2 [&>button]:text-[#FBF7F0] [&>button]:opacity-100 [&>button]:shadow-lg [&>button]:ring-offset-[#FBF7F0]"
          data-testid="deity-dialog"
        >
          {openDeity && (
            <>
              <div className="grid md:grid-cols-2">
                <div className="relative aspect-square md:aspect-auto md:min-h-[440px]">
                  {openDeity.isIdol ? (
                    <div className="absolute inset-0 bg-gradient-to-br from-[#FBF7F0] via-[#F2E7D5] to-[#E4D3B1] flex items-center justify-center overflow-hidden">
                      <div className="absolute inset-0 flex items-center justify-center opacity-45 animate-mandala-slow">
                        <Mandala size={420} color="#B65A14" opacity={0.6} />
                      </div>
                      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 45%, rgba(201,162,39,0.35) 0%, transparent 60%)" }} />
                      {openDeity.image ? (
                        <img
                          src={openDeity.image}
                          alt={openDeity.name}
                          className={`relative z-10 object-contain ${openDeity.slug === "bhuvaraha" ? "max-h-[64%] max-w-[55%]" : "max-h-[90%] max-w-[88%]"}`}
                          style={{ filter: "drop-shadow(0 12px 30px rgba(51,36,28,0.45))" }}
                        />
                      ) : (
                        <div className="relative z-10 text-center px-8">
                          <div className="w-28 h-28 mx-auto rounded-full border-2 border-[#B65A14]/60 flex items-center justify-center mb-5 bg-[#FBF7F0]/80">
                            <Sparkles className="w-12 h-12 text-[#B65A14]" />
                          </div>
                          <div className="font-serif-display text-2xl text-[#B65A14]">{copy.awaitingDarshana}</div>
                          <div className="text-[11px] uppercase tracking-widest text-[#3B2A1A]/70 mt-2">{copy.imageComingSoon}</div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <img src={openDeity.image} alt={openDeity.name} className="w-full h-full object-cover" />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#3B2A1A]/60 to-transparent" />
                    </>
                  )}
                </div>
                <div className="p-8 relative">
                  <div className="absolute -top-6 -right-6 opacity-20"><Mandala size={140} color="#D4AF37" opacity={0.9} /></div>
                  <DialogHeader>
                    {/* <div className="font-cinzel text-xs tracking-widest text-[#B65A14]">{openDeity.sanskrit}</div> */}
                    <DialogTitle className="font-serif-display text-3xl text-[#3B2A1A] leading-tight mt-1">
                      {(lang === "kn" && DEITY_CONTENT_KN[openDeity.slug]?.title) || pick(openDeity, "name")}
                    </DialogTitle>
                    <DialogDescription className="text-[#B65A14] italic mt-1">
                      {(lang === "kn" && DEITY_CONTENT_KN[openDeity.slug]?.note) || pick(openDeity, "tagline")}
                    </DialogDescription>
                  </DialogHeader>
                  {/* <div className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#B65A14]"><Clock className="w-3 h-3" /> {pick(openDeity, "timing")}</div> */}
                  <div className="mt-5 gold-underline" />
                  <div className="mt-5 space-y-4">
                    {((lang === "kn" && DEITY_CONTENT_KN[openDeity.slug]?.paragraphs) || [pick(openDeity, "intro")]).map((paragraph) => (
                      <p key={paragraph} className="text-sm text-[#3B2A1A]/85 leading-relaxed" style={{ textAlign: "justify" }}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                  {/* <div className="mt-5 p-4 rounded-xl bg-[#F2E7D5]/60 border border-[#D4AF37]/30">
                    <div className="overline text-[#B65A14] mb-2">{lang === "kn" ? "ಮಹತ್ವ" : "Significance"}</div>
                    <p className="text-sm text-[#3B2A1A]/85 leading-relaxed">{pick(openDeity, "significance")}</p>
                  </div> */}
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      <SectionDivider variant="lotus" />

      <CTASection
        eyebrow={copy.experienceSode}
        title={copy.planDarshana}
        primary={{ label: copy.templeTimings, to: "/events" }}
        secondary={{ label: copy.reachSode, to: "/contact" }}
        image={IMG.templeCorridor}
      />
    </PageLayout>
  );
};

export default Deities;
